












































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import UserService from '../services/UserService'
import { IEnvironment, IEnvironmentAddRequest, IEnvironmentDeleteRequest } from '../model/Environment'
import { IUser, INewUserRequest, IUserDeleteRequest } from '@/model/UserState'
import EnvironmentService from '@/services/EnvironmentService'


@Component({})
export default class AdminSettings extends Vue {
    userService: UserService;
    environmentService: EnvironmentService
    environments: IEnvironment[];
    users: IUser[];

    deleteEnvironmentDialog = false;
    envirnmentToDelete: IEnvironment;
    defaultEnvironment: IEnvironment;

    deleteUserDialog = false;
    userToDelete: IUser;
    defaultUser: IUser;

    newUserName = ""
    newUserPassword = ""

    newEnvironmentName = ""
    newEnvironmentPatchRemoval = false

    headersUsers: any[] = [
      { text: 'Name', value: 'name' },
      { text: 'Löschen', value: 'remove', sortable: false },
      
    ]

    headersEnvironment: any[] = [
      {text: 'Name', value: 'name'},
      {text: 'Patch Entfernung', value: 'allowPatchRemoval'},
      {text: 'Löschen', value: 'remove', sortable: false}
    ]

    constructor () {
      super()
      this.userService = new UserService()
      this.environmentService = new EnvironmentService()
      this.environments = []
      this.users = []
      this.envirnmentToDelete = {id: -1, name: "", allowPatchRemoval: false}
      this.defaultEnvironment = {id: -1, name: "", allowPatchRemoval: false}

      this.userToDelete = {id: -1, name: "", email: ""}
      this.defaultUser = {id: -1, name: "", email: ""}

    }

    created () {
      this.newEnvironmentName = ""
      this.newEnvironmentPatchRemoval = false
      this.newUserName = ""
      this.newUserPassword = ""
      this.loadInformation();
    }

    isStringEmpty(s: string){
      const k = s.split(" ").join();
      if(k === "" || k.length === 0){
        return true;
      }
      else{
        return false;
      }
    }

    loadInformation(){
      this.userService.getAllUsers().then(users => {
        this.users = users
      })
      this.environmentService.getAllEnvironments().then(environments => {
        this.environments = environments
      })
    }

    addNewUser() {
      const newUser: INewUserRequest = {
        userName: this.newUserName,
        userPassword: this.newUserPassword
      }

      this.userService.addNewUser(newUser).then(()=> {
        this.userService.getAllUsers().then(users => {
          this.users = users
          this.newUserName = ""
          this.newUserPassword = ""
        })
      })
    }

    deleteUser(item: IUser){
      this.userToDelete = Object.assign({}, item)
      this.deleteUserDialog = true;
    }

    deleteUserConfirm(){
      const deleteRequest: IUserDeleteRequest = {id: this.userToDelete.id}
      this.closeDialogs();
      this.userService.deleteUser(deleteRequest).then(res => {
        this.loadInformation();
      })
    }

    addNewEnvironment(){
      const addRequest: IEnvironmentAddRequest = {
        name: this.newEnvironmentName,
        allowPatchRemoval: this.newEnvironmentPatchRemoval
      }

      this.environmentService.addNewEnvironment(addRequest).then(() => {
        this.newEnvironmentName = ""
        this.newEnvironmentPatchRemoval = false
        this.environmentService.getAllEnvironments().then(environments => {
          this.environments = environments
          this.newEnvironmentName = ""
          this.newEnvironmentPatchRemoval = false;
        })
      })
    }

    deleteEnvironment(item: IEnvironment){
      this.envirnmentToDelete = Object.assign({}, item);
      this.deleteEnvironmentDialog = true;
    }

    deleteEnvironmentConfirm(){
      const deleteRequest: IEnvironmentDeleteRequest = {id: this.envirnmentToDelete.id}
      this.closeDialogs();
      this.environmentService.deleteEnvironment(deleteRequest).then(res => {
        this.loadInformation();
      })
    }

    closeDialogs(){
      this.deleteEnvironmentDialog = false;
      this.envirnmentToDelete = Object.assign({}, this.defaultEnvironment);

      this.deleteUserDialog = false;
      this.userToDelete = Object.assign({}, this.defaultUser);
    }
}

